export { default } from './SpecialPagesListContainer';



// WEBPACK FOOTER //
// ./src/components/SpecialPages/containers/SpecialPagesListContainer/index.js